import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { type ConfigResponse } from '../api/data/ConfigResponse'
import { useGetConfig } from '../api/hooks'
import { getDealerNumber, getOEMName } from '../modules/auth/helpers'
import { configAction } from '../store/reservationSlice'
import { type RootState } from '../store/store'

export function getConfig<T>(configName: string, refresh: boolean): T | undefined {
  const dispatch = useDispatch()
  const oemName = getOEMName()
  const dealerNumber = getDealerNumber()
  const storedConfigData: ConfigResponse[] | undefined = useSelector((state: RootState) => state.reservationSlice.configAction)
  if (!refresh) {
    refresh = typeof storedConfigData === 'undefined'
  }
  const { configData } = useGetConfig(oemName, dealerNumber, refresh)
  useEffect(() => {
    if (configData !== null && configData?.statusCode === 200 && configData?.data?.length > 0) {
      dispatch(configAction(configData?.data))
    }
  }, [configData, storedConfigData])

  const searchedConfig = (storedConfigData ?? configData.data)?.find((x) => x.name === configName)
  const isNotConfigured = typeof searchedConfig === 'undefined'
  const result: T | undefined = isNotConfigured ? searchedConfig : JSON.parse(searchedConfig?.value)
  return result
}
